/**
 * This file is @deprecated, use `client/src/utils/translation.js` instead
 */

// API метка client.news.show-more.button
export const showMoreButtonText = {
  'ar-AE': 'أظهر المزيد',
  'bg-BG': 'Покажи повече',
  'cs-CZ': 'Zobrazit více',
  'de-DE': 'Mehr anzeigen',
  'en-US': 'Show more',
  'es-ES': 'Mostrar más',
  'fr-FR': 'Montrer plus',
  'he-IL': 'הראו לי עוד',
  'hu-HU': 'Show more',
  'it-IT': 'Mostra di più',
  'ja-JP': '詳細を見る',
  'ko-KR': '더 보기',
  'pl-PL': 'Wyświetl więcej',
  'pt-BR': 'Mostrar mais',
  'ro-RO': 'Afișează mai multe',
  'ru-RU': 'Показать еще ',
  'th-TH': 'แสดงเพิ่มเติม',
  'tr-TR': 'Daha fazlasını göster',
  'vi-VN': 'Hiện thêm',
  'zh-CN': '显示更多',
  'zh-TW': '顯示更多',
};

// API метка client.buy_button.text
export const buyButtonText = {
  'ar-AE': 'اشترِ الآن',
  'bg-BG': 'Купете сега',
  'cs-CZ': 'Koupit nyní',
  'de-DE': 'Jetzt kaufen',
  'en-US': 'Buy now',
  'es-ES': 'Cómpralo ya',
  'fr-FR': 'Acheter maintenant',
  'he-IL': 'לקנייה',
  'hu-HU': 'Buy now',
  'it-IT': 'Compra ora',
  'ja-JP': '今すぐ購入',
  'ko-KR': '지금 구매하기',
  'pl-PL': 'Kup teraz',
  'pt-BR': 'Compre agora',
  'ro-RO': 'Cumpără acum',
  'ru-RU': 'Купить сейчас',
  'th-TH': 'ซื้อเลย',
  'tr-TR': 'Şimdi Satın al',
  'vi-VN': 'Mua ngay',
  'zh-CN': '立即购买',
  'zh-TW': '立即購買',
};

// API метка client.store.item.price_from
export const gamePriceFromLabels = {
  'ar-AE': 'من {price}',
  'bg-BG': 'от {price}',
  'cs-CZ': 'od {price}',
  'de-DE': 'ab {price}',
  'en-US': 'from {price}',
  'es-ES': 'desde {price}',
  'fr-FR': 'à partir de {price}',
  'he-IL': 'החל מ-{price}',
  'hu-HU': 'from {price}',
  'it-IT': 'a partire da {price}',
  'ja-JP': '最低{price}',
  'ko-KR': '{price}부터',
  'pl-PL': 'od {price}',
  'pt-BR': 'de {price}',
  'ro-RO': 'de la{price}',
  'ru-RU': 'от {price}',
  'th-TH': 'ตั้งแต่ {price}',
  'tr-TR': 'En düşük fiyat: {price}',
  'vi-VN': 'từ {price}',
  'zh-CN': '{price}起',
  'zh-TW': '{price} 起',
};

export const readMoreNewsButtonText = {
  'ar-AE': 'قراءة المزيد',
  'bg-BG': 'Прочетете още',
  'cs-CZ': 'Přečtěte si více',
  'de-DE': 'Weiterlesen',
  'en-US': 'Read more',
  'es-ES': 'Lee mas',
  'fr-FR': 'Lire la suite',
  'he-IL': 'อ่านเพิ่มเติม',
  'it-IT': 'Leggi di più',
  'ja-JP': '続きを読む',
  'ko-KR': '더 읽어보기',
  'pl-PL': 'Czytaj więcej',
  'pt-BR': 'Consulte Mais informação',
  'ro-RO': 'Citeste mai mult',
  'ru-RU': 'Читать далее',
  'th-TH': 'อ่านเพิ่มเติม',
  'tr-TR': 'Daha fazla oku',
  'vi-VN': 'Đọc thêm',
  'zh-CN': '阅读更多',
  'zh-TW': '閱讀更多',
};

export const localizedLanguagesNames = {
  'ar-AE': 'العَرَبِيَّة',
  'bg-BG': 'Български',
  'zh-CN': '简体中文',
  'cs-CZ': 'Čeština',
  'de-DE': 'Deutsch',
  'en-US': 'English',
  'es-ES': 'Español',
  'fr-FR': 'Français',
  'he-IL': 'עברית',
  'hu-HU': 'Magyar',
  'it-IT': 'Italiano',
  'ja-JP': '本語',
  'ko-KR': '한국어',
  'pl-PL': 'Polski',
  'pt-BR': 'Português',
  'ro-RO': 'Romanesci',
  'ru-RU': 'Русский',
  'th-TH': 'ไทย',
  'tr-TR': 'Türkçe',
  'zh-TW': '繁體中文',
  'vi-VN': 'Tiếng Việt',
};
